"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Wrench, Hammer, PaintRoller, TrendingUp, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Hail Damage Repairs",
  description: "Expert restoration for storm-damaged panels, ensuring your caravan returns to its pre-accident condition with precision.",
  icon: Hammer
}, {
  title: "Structural Restoration",
  description: "Comprehensive chassis and frame repairs to ensure the structural integrity and safety of your mobile home on the road.",
  icon: Wrench
}, {
  title: "New Installations",
  description: "Upgrade your travel experience with professional fitting of air conditioners, solar panels, and modern appliance systems.",
  icon: PaintRoller
}, {
  title: "Electrical & Plumbing",
  description: "Certified technical repairs and maintenance for your caravan's critical internal systems, ensuring safety and functionality.",
  icon: TrendingUp
}];
export default function CoreMaintenanceServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="2416" id="our-specialist-repair-services" ref={ref} className={`bg-background text-foreground py-24 px-4 md:px-8 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-primary">
            Specialist Caravan Repair Services
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Caravan Smash Repairs in South Windsor delivers expert insurance and private restoration solutions, ensuring your vehicle is restored to optimal condition.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => <div key={i} data-index={i} className="group relative flex flex-col justify-between p-8 bg-card text-card-foreground border border-border overflow-hidden transition-all duration-500 rounded-xl shadow-md hover:shadow-xl hover:border-secondary hover:-translate-y-1">
              <div className="flex flex-col items-start h-full">
                <div className="mb-6 p-3 border border-border rounded-md bg-muted group-hover:bg-secondary/10 group-hover:border-secondary/20 transition-colors duration-300">
                  <service.icon className="w-8 h-8 text-secondary" strokeWidth={2} />
                </div>
                
                <h3 className="text-2xl font-bold tracking-tight mb-2 group-hover:text-secondary transition-colors duration-300">
                  {service.title}
                </h3>

                <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-out">
                  <div className="overflow-hidden">
                    <p className="text-muted-foreground leading-relaxed pt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                      {service.description}
                    </p>
                  </div>
                </div>
                
                <div className="mt-auto pt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-4 group-hover:translate-y-0">
                  <span className="inline-flex items-center text-xs font-mono font-bold uppercase tracking-wider text-secondary">
                    Learn more <ArrowRight className="ml-2 w-4 h-4" />
                  </span>
                </div>
              </div>
              
              {}
              <div className="absolute top-0 right-0 w-0 h-0 border-t-[40px] border-r-[40px] border-t-transparent border-r-muted group-hover:border-r-secondary/20 transition-colors duration-300" />
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="text-base px-8 bg-accent text-accent-foreground hover:bg-accent/90 rounded-sm font-bold tracking-wide shadow-lg">
            <Link to="/StartYourQuotePage">
              Start Your Quote
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}